import { REP_CHANNELS } from '@constants/index';

/**
 * The two notification-contact catalogs share the same pages. ALOC contacts
 * (state organization 900) are triggered by county names; equipment contacts
 * belong to an organization and are triggered by organization names.
 */
export type NotificationDomain = 'lcert' | 'equipment';

export const NOTIFICATION_DOMAINS: Record<
  NotificationDomain,
  {
    basePath: string;
    backPath: string;
    title: string;
    subtitle: string;
    channel: string;
    trigger: { singular: string; plural: string; dialogTitle: string };
  }
> = {
  lcert: {
    basePath: '/lcert/notifications',
    backPath: '/lcert',
    title: 'ALOC notifications',
    subtitle: 'State contacts notified when a county submits its letter',
    channel: REP_CHANNELS.lcertNotifications,
    trigger: { singular: 'County', plural: 'Counties', dialogTitle: 'Select County' },
  },
  equipment: {
    basePath: '/equipment/notifications',
    backPath: '/equipment',
    title: 'Equipment notifications',
    subtitle: 'Contacts reminded 30 days before a calibration is due',
    channel: REP_CHANNELS.equipmentNotifications,
    trigger: {
      singular: 'Organization',
      plural: 'Organizations',
      dialogTitle: 'Select Organizations',
    },
  },
};
